export default "__VITE_ASSET__B18FeZ3L__"